module.exports = __webpack_public_path__ + "static/media/perfil-motorista.5b3b7e5f.png";